module.exports = __webpack_public_path__ + "static/hag_lair-fc8e477a351120c9e612a6ffef6f4d17.png";